import { cn } from '@/lib/utils';

// Skeleton blocks use the `skeleton` utility (src/styles/app.css): --skeleton
// fill with an opacity-only shimmer that stops under reduced motion (§3.1).
// Size them to the final layout; a bare "Loading…" never replaces a region.
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn('skeleton', className)}
      {...props}
    />
  );
}

export { Skeleton };
